var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9598 11.531C5.47958 12.7541 6.4639 13.7205 7.69625 14.2178C8.92859 14.7151 10.308 14.7024 11.531 14.1826C12.754 13.6629 13.7205 12.6785 14.2178 11.4462C14.715 10.2139 14.7024 8.83445 14.1826 7.61142C13.6629 6.3884 12.6785 5.42195 11.4462 4.92467C10.2138 4.4274 8.83444 4.44004 7.61141 4.95981C6.38839 5.47959 5.42194 6.46391 4.92467 7.69626C4.42739 8.9286 4.44003 10.308 4.9598 11.531V11.531Z",
    stroke: "#808080",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.114 13.1139L17.0001 17.0005",
    stroke: "#808080",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.61b1c747aa872b5ab4aa8c43b0dec52b.svg";
export { ForwardRef as ReactComponent };